import { Flex, Input, Text, useToast } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useOrcamentoPedido } from '../../../../contexts/OrcamentoPedidoProvider'
import { useForm } from 'react-hook-form'
import { api } from '../../../../services/api'
import { useMutation } from 'react-query'

async function onUpdateDataSaida(data) {
  const response = await api.put('https://api.innovationbrindes.com.br/api/site/v2/orcamento-crm/atualiza-data-saida', data)

  return response.data
}

export const DataSaida = () => {
  const { infoProposta } = useOrcamentoPedido()
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })
  const { register, handleSubmit, setValue } = useForm()

  const { mutateAsync } = useMutation({
    mutationFn: onUpdateDataSaida,
    onSuccess: (data) => {
      toast({
        title: `Data de saída do material alterada para ${data.data_saida}`,
        status: 'success',
      })
    },
    onError: (error) => {
      toast({
        title: `Erro ao alterar a data de saída do material: ${error['response']['data']['erros']}`,
        status: 'error',
      })
    },
  })

  async function onSubmit(data) {
    await mutateAsync({ numero_nota: infoProposta.num_proposta, data_saida: data.data_saida })
  }

  useEffect(() => {
    setValue('data_saida', infoProposta?.data_saida)
  }, [infoProposta?.data_saida, setValue])

  if (!infoProposta?.data_saida) {
    return null
  }

  return (
    <Flex alignItems="center" gap={2} as="form" onChange={handleSubmit(onSubmit)}>
      <Text maxW="160px" w="full">
        Data Saída Material:
      </Text>
      <Input type="date" size="sm" borderRadius={0} {...register('data_saida')} />
    </Flex>
  )
}
